import "../../utils/tailwind.css";
import { PageProvider, usePageProvider } from "./provider";
import Section from "../../components/section";
import React from "react";
import { Accordion } from "react-bootstrap";
import { Formik, Form, FieldArray } from "formik";
import { FormikInput } from "../../components/input";
import Plus from "../../components/svg/plus";
import Label from "../../components/label";
import Trash from "../../components/svg/trash";
import ImageUploader from "../../components/upload-image";
import Button from "../../components/Buttons";
import { FormikTextarea } from "../../components/textarea";
import { FormikDropdown } from "../../components/dropdown";

export default function AddUser() {
  return (
    <div className="p-3 bg-[#fffbf4] ">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, monialsRef, getFaqQuery, handleSubmit } = usePageProvider();

  return (
    <Section>
      <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
        {({ values, setFieldValue }) => (
          <Form>
            <Accordion defaultActiveKey="0" className="mt-5">
              <Accordion.Item eventKey="1" className="w-[100%]  ml-[1rem] ">
                <Accordion.Header>SEO META</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div className="flex flex-col">
                      <Label label="Meta Title" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_title" rootClassName="w-full" />
                    </div>
                    <div className="flex flex-col">
                      <Label label="Meta Keywords" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_keyword" rootClassName="w-full" />
                    </div>

                    <div className="flex flex-col">
                      <Label label="Meta Description" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="meta_seo.meta_desc" rootClassName="w-full" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2" className="w-[100%]  ml-[1rem] ">
                <Accordion.Header>Header</Accordion.Header>
                <Accordion.Body>
                  <Accordion>
                    <Accordion.Item eventKey="19">
                      <Accordion.Header>Banner Details</Accordion.Header>
                      <Accordion.Body>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                          <div className="flex flex-col">
                            <Label label="Primary Heading" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="header.primary_heading" rootClassName="w-full" />
                          </div>

                          <div className="flex flex-col">
                            <Label label="Secondery Heading" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="header.secondary_heading" rootClassName="w-full" />
                          </div>
                        </div>
                        <div className="flex flex-col mt-2">
                          <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                          <FormikTextarea name="header.description" rootClassName="w-full" as="textarea" />
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <Accordion className="my-2">
                    <Accordion.Item eventKey="21">
                      <Accordion.Header>Redirect Buttons</Accordion.Header>
                      <Accordion.Body>
                        <div className="grid grid-cols-1 sm:grid-cols-4 my-4 gap-3">
                          <div className="flex flex-col">
                            <Label label="Primary CTA Label" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="header.primary_cta.label" rootClassName="w-full" />
                          </div>
                          <div className="flex flex-col">
                            <Label label="Primary CTA Redirect Link" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="header.primary_cta.redirect_url" rootClassName="w-full" />
                          </div>
                          <div className="flex flex-col">
                            <Label label="Secondary CTA Label" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="header.secondary_cta.label" rootClassName="w-full" />
                          </div>
                          <div className="flex flex-col">
                            <Label label="Secondary CTA Redirect Link" className="mb-2 text-black text-[15px] font-semibold" />
                            <FormikInput name="header.secondary_cta.redirect_url" rootClassName="w-full" />
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3" className="w-[100%] ml-[1rem]">
                <Accordion.Header>Banner</Accordion.Header>

                <Accordion.Body>
                  <FieldArray
                    name="banners"
                    render={(arrayHelpers) => (
                      <>
                        <div className="flex justify-end mb-1 mt-2">
                          <div
                            className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer"
                            onClick={() => {
                              arrayHelpers.push({
                                title: "",
                                description: "",
                                details: "",
                                icon: "",
                                desktop_image_url: "",
                                alt_tag: "",
                              });
                            }}
                          >
                            <Plus className="text-white" />
                          </div>
                        </div>

                        <div className="overflow-x-auto mt-4">
                          <table className="w-full border border-gray-300 text-sm table-fixed">
                            <thead className="bg-gray-100">
                              <tr>
                                <th className="w-[15.66%] font-normal border px-3 py-2 text-left">Title</th>
                                <th className="w-[15.66%] font-normal border px-3 py-2 text-left">Description</th>
                                <th className="w-[15.66%] font-normal border px-3 py-2 text-left">Details</th>
                                <th className="w-[15.66%] font-normal border px-3 py-2 text-left">Icon</th>
                                <th className="w-[15.66%] font-normal border px-3 py-2 text-left">Image</th>
                                <th className="w-[15.66%] font-normal border px-3 py-2 text-left">Alt Tag</th>
                                <th className="w-[6%] border px-3 py-2 font-normal text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {values.banners.map((item, index) => (
                                <tr key={`banner-${index}`} className="align-top">
                                  <td className="border px-3 py-2">
                                    <FormikInput name={`banners.${index}.title`} rootClassName="w-full" />
                                  </td>
                                  <td className="border px-3 py-2">
                                    <FormikTextarea name={`banners.${index}.details`} rootClassName="w-full" />
                                  </td>
                                  <td className="border px-3 py-2">
                                    <FormikInput name={`banners.${index}.description`} rootClassName="w-full" />
                                  </td>
                                  <td className="border px-3 py-2">
                                    <ImageUploader
                                      title="Icon"
                                      imageUrl={item.icon}
                                      onChange={(res) => setFieldValue(`banners.${index}.icon`, res?.data?.file_url)}
                                    />
                                  </td>
                                  <td className="border px-3 py-2">
                                    <ImageUploader
                                      title="Desktop"
                                      imageUrl={item.desktop_image_url}
                                      onChange={(res) => setFieldValue(`banners.${index}.desktop_image_url`, res?.data?.file_url)}
                                    />
                                  </td>
                                  <td className="border px-3 py-2">
                                    <FormikInput name={`banners.${index}.alt_tag`} rootClassName="w-full" />
                                  </td>
                                  <td className="w-[6%] border border-gray-300 px-4 py-2 text-center">
                                    <div className="flex justify-center cursor-pointer" onClick={() => arrayHelpers.remove(index)}>
                                      <Trash />
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </>
                    )}
                  />
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4" className="w-[100%] ml-[1rem] ">
                <Accordion.Header>Smart Add-ons</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-1 gap-3">
                    <div className="flex flex-col">
                      <Label label="Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="section_add_ons.title" rootClassName="w-full" />
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <Label label="Description" className="mb-2 text-black text-[15px] font-semibold" />
                    <FormikTextarea name="section_add_ons.description" rootClassName="w-full" as="textarea" />
                  </div>

                  <FieldArray name="section_add_ons.add_ons">
                    {(arrayHelpers) => (
                      <div className="mt-6">
                        <div className="flex justify-between items-center mb-3">
                          <h3 className="text-lg font-medium">Add Images</h3>
                          <button
                            type="button"
                            className="bg-[#7C13CA] text-white p-2 rounded-full"
                            onClick={() => arrayHelpers.push({ image_url: "", alt_tag: "" })}
                          >
                            <Plus className="h-4 w-4" />
                          </button>
                        </div>

                        <div className="overflow-x-auto">
                          <table className="w-full table-fixed border-collapse border border-gray-300">
                            <thead className="bg-gray-200">
                              <tr>
                                <th className="w-[80%] border font-normal border-gray-300 px-2 py-2 text-left">Image</th>
                                <th className="w-[80%] border font-normal border-gray-300 px-2 py-2 text-left">Alt Tag</th>
                                <th className="w-[10%] border font-normal border-gray-300 px-2 py-2 text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {values?.section_add_ons?.add_ons?.map((item, index) => (
                                <tr key={index}>
                                  <td className="w-[70%] border border-gray-300 px-4 py-2">
                                    <ImageUploader
                                      imgStyle={{ width: "8rem" }}
                                      title="Image"
                                      imageUrl={item?.image_url}
                                      onChange={(res) => setFieldValue(`section_add_ons.add_ons.${index}.image_url`, res?.data?.file_url)}
                                    />
                                  </td>
                                  <td className="border px-2 py-2">
                                    <FormikInput name={`section_add_ons.add_ons.${index}.alt_tag`} rootClassName="w-full" />
                                  </td>
                                  <td className="w-[20%] border border-gray-300 px-4 py-2">
                                    <div className="flex justify-center cursor-pointer" onClick={() => arrayHelpers.remove(index)}>
                                      <Trash />
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </FieldArray>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="5" className="w-[100%] ml-[1rem]">
                <Accordion.Header>Cards Section</Accordion.Header>
                <Accordion.Body>
                  <FieldArray
                    name="multi_cards_section"
                    render={(arrayHelpers) => (
                      <>
                        <div className="flex justify-end mb-1">
                          <div
                            className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer"
                            onClick={() => {
                              arrayHelpers.push({
                                title: "",
                                description: "",
                                details: "",
                                icon: "",
                                desktop_image_url: "",
                                alt_tag: "",
                              });
                            }}
                          >
                            <Plus className="text-white" />
                          </div>
                        </div>

                        <div className="overflow-x-auto mt-4">
                          <table className="w-full border border-gray-300 text-sm table-fixed">
                            <thead className="bg-gray-100">
                              <tr>
                                <th className="w-[13.43%] font-normal border px-3 py-2 text-left">Primary Heading</th>
                                <th className="w-[13.43%] font-normal border px-3 py-2 text-left">Secondary Heading</th>
                                <th className="w-[13.43%] font-normal border px-3 py-2 text-left">Description</th>
                                <th className="w-[13.43%] font-normal border px-3 py-2 text-left">Details</th>
                                <th className="w-[13.43%] font-normal border px-3 py-2 text-left">Icon</th>
                                <th className="w-[13.43%] font-normal border px-3 py-2 text-left">Desktop Image</th>
                                <th className="w-[13.43%] font-normal border px-3 py-2 text-left">Alt Tag</th>
                                <th className="w-[6%] border font-normal px-3 py-2 text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {values.multi_cards_section.map((item, index) => (
                                <tr key={`multi-card-${index}`} className="align-top">
                                  <td className="w-[15.67%] border px-3 py-2">
                                    <FormikInput name={`multi_cards_section.${index}.title`} rootClassName="w-full" />
                                  </td>
                                  <td className="w-[15.67%] border px-3 py-2">
                                    <FormikInput name={`multi_cards_section.${index}.secondary_title`} rootClassName="w-full" />
                                  </td>
                                  <td className="w-[15.67%] border px-3 py-2">
                                    <FormikTextarea name={`multi_cards_section.${index}.description`} rootClassName="w-full" />
                                  </td>
                                  <td className="w-[15.67%] border px-3 py-2">
                                    <FormikInput name={`multi_cards_section.${index}.details`} rootClassName="w-full" />
                                  </td>
                                  <td className="w-[15.67%] border px-3 py-2">
                                    <ImageUploader
                                      title="Icon"
                                      imageUrl={item.icon}
                                      onChange={(res) => setFieldValue(`multi_cards_section.${index}.icon`, res?.data?.file_url)}
                                    />
                                  </td>
                                  <td className="w-[15.67%] border px-3 py-2">
                                    <ImageUploader
                                      title="Desktop"
                                      imageUrl={item.desktop_image_url}
                                      onChange={(res) => setFieldValue(`multi_cards_section.${index}.desktop_image_url`, res?.data?.file_url)}
                                    />
                                  </td>
                                  <td className="w-[15.67%] border px-3 py-2">
                                    <FormikInput name={`multi_cards_section.${index}.alt_tag`} rootClassName="w-full" />
                                  </td>
                                  <td className="w-[6%] border px-4 py-2 text-center">
                                    <div className="flex justify-center cursor-pointer" onClick={() => arrayHelpers.remove(index)}>
                                      <Trash />
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </>
                    )}
                  />
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="6" className="w-[100%] ml-[1rem] mb-8">
                <Accordion.Header>FAQ's</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-1 gap-3">
                    <div className="flex flex-col">
                      <Label label="FAQ Heading" className="mb-2 text-black text-[15px] font-semibold" />
                      <FormikInput name="testimonials.heading" rootClassName="w-full" />
                    </div>
                  </div>
                  <div className="flex justify-end mb-2">
                    <div className="bg-[#7C13CA] p-1 rounded-full w-auto cursor-pointer" onClick={() => monialsRef?.current?.push({ faq: "" })}>
                      <Plus className="text-white" />
                    </div>
                  </div>

                  <FieldArray name="testimonials.testimonials">
                    {(arrayHelpers) => {
                      monialsRef.current = arrayHelpers;

                      return (
                        <div className="mt-2 overflow-x-auto">
                          <table className="w-full table-fixed border-collapse border border-gray-300">
                            <thead className="bg-gray-200">
                              <tr>
                                <th className="w-[94%] border font-normal border-gray-300 px-2 py-2 text-left">Faq</th>
                                <th className="w-[6%] border font-normal border-gray-300 px-2 py-2 text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {values?.testimonials?.testimonials?.map((item, index) => (
                                <tr key={index}>
                                  <td className="border border-gray-300 px-4 py-2">
                                    <FormikDropdown
                                      options={getFaqQuery?.data?.data?.data?.map((item) => ({
                                        label: item.ques,
                                        value: item.id,
                                      }))}
                                      name={`testimonials.testimonials.${index}.faq`}
                                      rootClassName="w-full"
                                    />
                                  </td>
                                  <td className="border border-gray-300 px-4 py-2 text-center">
                                    <div className="flex justify-center cursor-pointer" onClick={() => monialsRef?.current?.remove(index)}>
                                      <Trash />
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      );
                    }}
                  </FieldArray>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <div className="fixed bottom-0 z-[999] left-0 w-full bg-[#fef5e4] flex justify-end items-center py-3 rounded-lg pr-4 space-x-3 shadow-md">
              <Button
                type="submit"
                className="!border-none text-white rounded-md !bg-[#7C13CA] hover:!bg-[#ffd869] hover:!text-black transition-colors duration-200"
              >
                Save
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
